import React from 'react';

import PropTypes from 'prop-types';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { bem } from 'helpers/class-name';

import flyoutMessages from '../shared/SkuOrderFlyout.messages';
import messages from './SkuOutOfStockConfirmModal.messages';

export const SKU_OUT_OF_STOCK_CONFIRM_MODAL_NAME = 'SkuOutOfStockConfirmModal';

const { block } = bem('sku-out-of-stock-confirm-modal');

const SkuOutOfStockConfirmModal = ({ onConfirm, onCancel, onRequestClose }) => (
  <Confirm
    className={block()}
    title={<Message message={messages.title} />}
    hasCloseButton
    onRequestClose={onRequestClose}
    onCancel={onCancel}
    cancelNode={<Message message={messages.goBack} />}
    acceptNode={<Message message={flyoutMessages.cancelOrder} />}
    acceptStyle="danger-solid"
    onConfirm={onConfirm}>
    <Message message={messages.body} />
  </Confirm>
);

SkuOutOfStockConfirmModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func,
};

export default SkuOutOfStockConfirmModal;
